module.exports = __webpack_public_path__ + "files/62291b788f6476f8d63aebfc07590114.png";